window.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body')!;
  const headerButtonSp = document.querySelector(
    '.headerNavigationButton[data-js="trueSp"]'
  )!;
  const headerButtonPc = document.querySelector(
    '.headerNavigationButton[data-js="truePc"]'
  )!;
  const headerFixMenu = document.querySelector(
    '.headerFixMenu[data-js="true"]'
  )!;
  const headerModalMenu = document.querySelector(
    '.headerModalMenu[data-js="true"]'
  )!;

  const headerFixBannerClose = document.querySelector('.fixFrontBannerClose')!;
  const headerFixBanner = document.querySelector(
    '.fixFrontBanner'
  ) as HTMLElement;

  headerButtonSp?.addEventListener('click', () => {
    headerButtonSp.classList.toggle('on');
    headerFixMenu.classList.toggle('on');
    body.classList.toggle('fix');
  });

  headerButtonPc?.addEventListener('click', () => {
    headerButtonPc.classList.toggle('on');
    headerModalMenu.classList.toggle('on');
    body.classList.toggle('fix');
  });

  headerFixBannerClose?.addEventListener('click', () => {
    headerFixBanner.style.display = 'none';
  });
});
